import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['toggle'];

  setOpen(open) {
    if (open) {
      document.querySelectorAll('.navbar-action-navigation.is-active').forEach(element => {
        if (element === this.element) return;
        element.classList.remove('is-active');
        element.querySelector('[data-navigation-menu-target="toggle"]').setAttribute('aria-expanded', 'false');
      });
    }
    this.element.classList.toggle('is-active', open);
    this.toggleTarget.setAttribute('aria-expanded', String(open));
  }

  toggle(event) {
    event.preventDefault();
    this.setOpen(!this.element.classList.contains('is-active'));
  }

  show(event) {
    if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) this.setOpen(true);
  }

  leave(event) {
    if (event.pointerType === 'mouse' && !this.element.contains(document.activeElement)) this.setOpen(false);
  }

  close() { this.setOpen(false); }

  dismiss(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  escape(event) {
    if (event.key !== 'Escape' || !this.element.classList.contains('is-active')) return;
    this.close();
    this.toggleTarget.focus();
  }
}
